import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { useGetCertificationsQuery } from "@/redux/service";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { Roles } from "@/shared/utils/constants";
import { isPaginatedResponse } from "@/redux/typeGuards";
import {
  certificationPaths,
  certificationRouteKey,
} from "@/domains/certifications/routes";
import DetailsSkeleton from "@/features/certifications/details/components/DetailsSkeleton";
import { ENROLLMENT_STATES } from "@/domains/certifications/constants";

const CertificationsIndex = () => {
  const currentUser = useSelector(selectCurrentUser);
  const { data, isError } = useGetCertificationsQuery();

  if (isError) {
    return <Navigate to="/" replace />;
  }

  if (!data) {
    return <DetailsSkeleton />;
  }

  const certifications = isPaginatedResponse(data) ? data.results : data;
  const certification = certifications[0];

  if (!certification) {
    return <Navigate to="/" replace />;
  }

  if (currentUser?.role === Roles.ADMIN.value) {
    return (
      <Navigate
        to={certificationPaths.admin(certificationRouteKey(certification))}
        replace
      />
    );
  }

  const isEnrolled =
    certification.enrollment?.state === ENROLLMENT_STATES.ACTIVE;

  return (
    <Navigate
      to={
        isEnrolled
          ? certificationPaths.overview(certificationRouteKey(certification))
          : certificationPaths.details(certificationRouteKey(certification))
      }
      replace
    />
  );
};

export default CertificationsIndex;
